import React, {Component} from 'react';
import {ControlBar, Player, VolumeMenuButton, Shortcut} from 'video-react';
import {Link} from 'react-router-dom';
import api from '../../utils/api';

/* global $ */

class VideoPlayer extends Component {
    constructor(props, context){
        super(props, context);
        this.state = {
            source: '',
            attempts: 1,
            studyTime: 0,
            count: 0,
            show: false,
            currentPercent: 0,
            durationVideo: 0,
            duration: 0,
            currentTime: 0,
            videoId: null,
            player: {},
            volume: 1,
            volumeControl: false,
            settingVolume: false,
            settingVolumePercent: 50,
            muted: false,
            showQuiz: false,
            playing: true,
            backward: false,
            left: 0,
            hoverTime: 0,
            currentModalQuestionIndex: 0,
            currentModalOptionIndex: 0,
            textTracksMode: 'showing',
            isFullscreen: false,
            marks: [],
            showSeek: false,
            showSummaryAndStuff: true,
            showNextVideo: false,
            markedShowQuiz: false,
            markedNext: false,
            listening: false,
            audioAnswer: '',
            audio: null,
            userTime: -1,
            lastUpdatedTime: 10,
            startTime: new Date(),
            timerId: null,
            setTimer: false,
            currentSeconds: 0,
            initialSeek: false,
            showReadOnlyQuestion: false,
            nextChapterPart: {},
            playbackRate: 1,
            throwback: -1,
            throwForward: -1,
            markedDone: false,
            height: window.innerHeight,
            width: window.innerWidth,
            isDragging: false,
            hoverSeconds: 0
        }
    }
    
    updateDimensions = () => {
        this.setState({width: window.innerWidth, height: window.innerHeight});
    }
    
    componentWillMount = () => {
        this.updateDimensions();
    }
    
    componentDidMount = () => {
        window.addEventListener("resize", this.updateDimensions);
    }
    
    componentWillUnmount = () => {
        window.removeEventListener("resize", this.updateDimensions);
    }
    
    
    /***************************************************************************
     * 
     * 
     * L I F E C Y C L E    C H A N G E S
     * 
     * 
     * ************************************************************************/
    initVideo = (changed) => {
        if((!this.state.source || changed) && this.props.videoFile && (this.props.userLecture || this.props.embedded)){
            this.setState({source: api.makeVideoURL(this.props.videoFile.name), playing: (!this.props.embedded)}, () => {
                if (this.refs.player) {
                    this.refs.player.load();

                    let self = this;
                    this.refs.player.video.video.addEventListener("loadedmetadata", function() {

                        // We can't dynamically load <tracks> for subtitles, so we have to hook into the onload of the video...
                        var track = document.createElement("track");
                        track.kind = "captions";
                        track.label = "English";
                        track.srclang = "en";
                        track.src = api.makeFileURL(self.props.videoFile.subtitles, self.props.user.id);
                        track.addEventListener("load", function() {
                            this.mode = "showing";
                            self.refs.player.video.video.textTracks[0].mode = "showing"; // thanks Firefox
                        });
                        this.appendChild(track);
                    }, true);

                    if (!this.state.listening) {

                        this.onListenBegin();


                         this.refs.player.subscribeToStateChange(this.handleStateChange.bind(this));

                        
                        
                        this.setState({listening: true}, () => {
                            if(this.props.profile.role){

                                    if (!this.state.initialSeek) {
                
                
                                        if (this.props.userLecture.currentTime) {
                                            if(this.props.userLecture.Lecture.VideoFile[0].duration){
                                                if(this.props.userLecture.currentTime >= this.props.userLecture.Lecture.VideoFile[0].duration && this.props.userLecture.completed){
                                                }else{
                                                    let skipCounts = 0;
                                                    this.props.chapterPart.VideoQuestions.filter(q => {
                                                        if (q.time < this.props.userLecture.currentTime) {
                                                            return skipCounts += 1;
                                                        }else{
                                                            return null;
                                                        }
                                                    });
                        
                                                    this.setState({initialSeek: true, count: skipCounts}, () => {
                                                        let self = this;
                        
                        
                                                        setTimeout(function () {
                        
                                                            self.changeCurrentTime(self.props.userLecture.currentTime);
                                                            self.refs.player.seek(self.props.userLecture.currentTime);
                                                        }, 500);
                                                    });
                                                }
                                            }else if(this.props.userLecture.duration){
                                                if(this.props.userLecture.currentTime >= this.props.userLecture.duration && this.props.userLecture.completed){

                                                }else{
                                                    let skipCounts = 0;
                                                    this.props.chapterPart.VideoQuestions.filter(q => {
                                                        if (q.time < this.props.userLecture.currentTime) {
                                                            return skipCounts += 1;
                                                        }else{
                                                            return null;
                                                        }
                                                    });
                        
                                                    this.setState({initialSeek: true, count: skipCounts}, () => {
                                                        let self = this;
                        
                        
                                                        setTimeout(function () {
                        
                                                            self.changeCurrentTime(self.props.userLecture.currentTime);
                                                            self.refs.player.seek(self.props.userLecture.currentTime);
                                                        }, 500);
                                                    });
                                                }
                                            }
                                        }
                                    }
            
                                
                            }
                        });

                        
                    }


                }
            });
        }
    }
    
    componentDidMount() {
        if(this.props.embedded){
            this.initVideo(false);
        }
        if(this.props.videoFile && this.props.courseUser) {
            this.initVideo(false);
        }
    }
    
    componentDidUpdate(props,state){
        if(!state.markedDone && this.state.markedDone){
            this.props.onFinish();
        }
        if(!props.courseUser && this.props.courseUser && !this.state.listening){
            this.initVideo(false);
        }
        
        if(this.props.videoFile !== props.videoFile || (this.props.videoFile && !this.state.listening)) {
            // console.log("update");
            this.initVideo(true);
        }
    }
    
    

    
    /***************************************************************************
     * 
     * 
     *  S T A T E    C H A N G E S
     * 
     * 
     * ************************************************************************/
    
    handleStateChange(state) {
        if(!this.state.listening){
            return false;
        }
        this.setState({
            player: state
        });
        const current = Math.ceil(state.currentTime);
        let duration = state.duration;
        let currentPercent = current * 100 / duration;
        let durationVideo =
            Math.floor(duration / 60) + ':' +
            (Math.floor(duration % 60) < 10
                ? '0' + Math.ceil(duration % 60)
                : Math.ceil(duration % 60));
        let currentTime =
            Math.floor(current / 60) + ':' +
            (Math.ceil(current % 60) < 10
                ? '0' + Math.ceil(current % 60)
                : Math.ceil(current % 60));
                
        
        
        let frameQuestions = this.props.fullVideoQuestions.filter(q => q.time === Math.ceil(current));
        let currentQuestion = (this.props.fullVideoQuestions[this.props.count]) ? this.props.fullVideoQuestions[this.props.count].time <= Math.ceil(current) : false;

        if(frameQuestions){
            //// console.log("Got questions", frameQuestions);
            //// console.log("CurrentQuestion: ", currentQuestion);
        }

        if(frameQuestions.length > 0 && this.state.show === false && currentQuestion){
            if(this.state.showSeek === false) {
                this.pause();
                this.props.showVideoQuestion(frameQuestions);
                this.setState({
                    show: true,
                    showQuestion: true,
                    showReadOnlyQuestion: false
                });
            }
        }else{
            if(this.props.embedded){
                this.props.updateCurrentTime(currentTime);
            }
            this.setState({
                currentPercent: currentPercent,
                durationVideo: durationVideo,
                duration: duration,
                currentTime: currentTime,
                currentSeconds: current,
                show: false
            });
        }

        
        

        if (state.ended && Math.ceil(this.state.player.currentTime) === Math.ceil(duration) && this.state.player.currentTime > 10 && this.state.listening) {
            let self = this;
            this.setState({markedDone: true}, () => {
                self.refs.player.pause();
                self.props.onFinish();
                
            });
        }

    }
    
      onListenBegin = () => {
        this.refs.player.forward = (e) => {
            return false;
        }
        this.refs.player.onKeyDown = (e) => {
            return false;
        }
    }



    
    
    /***************************************************************************
     * 
     * 
     *  C O M P O N E N T    P L A Y E R    C H A N G E S
     * 
     * 
     * ************************************************************************/
    
    
    play = () => {

        this.refs.player.play();
        this.setState({
            playing: true
        })    

        
    };

    pause = () => {
        this.refs.player.pause();
        this.setState({
            playing: false
        })
    };
    
    seekTo(seconds){
        const {player} = this.refs.player.getState();
        const currentTime = player.currentTime;
        if(!this.props.embedded && currentTime > seconds) {
            // console.log("Not seeking..");
            this.setState({show: false, showSeek: false}, () => {
                this.refs.player.seek(seconds);
                this.play();

            });
        }else {
            this.setState({show: false, showSeek: false}, () => {
                this.refs.player.seek(seconds);
                this.play();

            });

        }
    }

    changeCurrentTime = (seconds) => {
        if(this.refs.player){
        const {player} = this.refs.player.getState();
        if(this.props.fullVideoQuestions[this.state.count]) {
            if (seconds < this.props.fullVideoQuestions[this.state.count].answerAt) {
                if (this.state.count - 1 === 0) {
                    this.refs.player.seek(0);
                } else {


                    this.setState({showSeek: false, show: false}, () => {
                        this.refs.player.seek(this.props.fullVideoQuestions[this.state.count].answerAt);
                        this.play();
                    });

                }

            } else {
                // console.log("Should seek to 0");
                this.setState({show: false, showSeek: false}, () => {
                    this.refs.player.seek(this.props.fullVideoQuestions[this.state.count].answerAt);
                    this.play();

                });

            }
        }else {
            this.setState({show: false, showSeek: false}, () => {
                this.refs.player.seek(seconds);
                this.play();

            });

        }
    }
    };

    seek = (seconds) => {
        return () => {
            if(this.refs.player){
                this.refs.player.seek(seconds);
            }
        };
    };

    changePlaybackRateRateold = (steps) => {
        if (this.state.playing) {
            return () => {
                const {player} = this.refs.player.getState();
                const playbackRate = player.playbackRate;
                if (this.refs.player.playbackRate > 0) {
                    this.refs.player.playbackRate = steps;
                }
                this.refs.player.setState({playbackRate: steps});
            };
        } else {
            return null
        }
    };

    changePlaybackRateRate = (steps) => {

        this.setState({playbackRate: steps}, ()=> {
            const {player} = this.refs.player.getState();
            const playbackRate = player.playbackRate;
            this.refs.player.playbackRate = steps;
        })


    };

    setMuted = (muted) => {
        return () => {
            this.refs.player.muted = muted;
        };
    };

    setFullScreen = () => {
        this.refs.player.toggleFullscreen();
    };

    setForward = () => {


        this.refs.player.seek(this.props.fullVideoQuestions[this.state.count].answerAt);
    };

    setBackward = () => {



        if (this.state.count - 1 === -1){
            this.refs.player.seek(0);
        } else {

            if (!this.state.backward){
                this.refs.player.seek(this.props.fullVideoQuestions[this.state.count - 1].answerAt);
                this.setState({backward: true, count: this.state.count - 1})
            } else {
                this.refs.player.seek(this.props.fullVideoQuestions[this.state.count - 2].answerAt);
                this.setState({backward: false, count: this.state.count - 2})
            }
            //this.setState({count: (this.state.count - 1)});
        }
    };


    onMouseMove = (e) => {
        let el = document.getElementsByClassName('wrap-progress-yt')[0].offsetWidth;
        let mouseX = e.nativeEvent.offsetX;
        let hoverSeconds = (this.state.duration * mouseX / el < 1)
            ? 0
            : Math.ceil(this.state.duration * mouseX / el);

        let remainingSeconds = (Math.floor(hoverSeconds % 60) < 10) ? "0" + Math.floor(hoverSeconds % 60).toString() : Math.floor(hoverSeconds % 60);
        let hoverTime = Math.floor(hoverSeconds / 60) + ':' + remainingSeconds;
        this.setState({
            left: mouseX,
            hoverTime: hoverTime,
            hoverSeconds: hoverSeconds
        });
    };

    toggleSubtitleShowState = () => {
        const textTracks = this.refs.player.video.video.textTracks;

        if (this.state.textTracksMode === 'showing') {
            this.setState({
                    textTracksMode: 'hidden'
                },
                () => {
                    textTracks[0].mode = this.state.textTracksMode;
                }
            );
        } else {
            this.setState({
                    textTracksMode: 'showing'
                },
                () => {
                    textTracks[0].mode = this.state.textTracksMode;
                }
            );
        }
    };

    onSeekVideo = (e, completed) => {
        let el = document.getElementsByClassName('wrap-progress-yt')[0].offsetWidth;
        let mouseX = e.nativeEvent.offsetX;
        let hoverSeconds = (this.state.duration * mouseX / el < 1)
            ? 0
            : this.state.duration * mouseX / el;

        let percent = Math.ceil((mouseX - el.left) / e.target.offsetWidth * 100);
        let seconds = Math.ceil(this.state.duration * (percent / 100));
            /*
        if(process.env.NODE_ENV === "dev"){
            this.refs.player.seek(hoverSeconds);
        }else */
            if(!completed && !this.props.embedded){
            // If user hasn't completed video already, don't allow forward seeking...
            // NOTE: Allow up to ul.maxTime
            if(hoverSeconds <= this.props.userLecture.maxTime){
                this.refs.player.seek(hoverSeconds);
            }else{
                this.refs.player.seek(hoverSeconds);
                //this.refs.player.seek(this.props.userLecture.maxTime);
            }
            if(hoverSeconds > this.state.currentSeconds){
                return false;
            }
        }

        if(this.props.fullVideoQuestions && this.props.count >= 0){
            // console.log("Determining whether seek allowed.");
            if(this.props.fullVideoQuestions[this.props.count]){
                // console.log("Have a current video question.", this.props.fullVideoQuestions[this.props.count]);

                // Test if user has already answered;
                let {userVideoQuestions} = this.props;
                let question = {completed: false};

                userVideoQuestions.map(v => {
                    if (v.videoQuestionId === this.props.fullVideoQuestions[this.props.count].id) {
                        return question = v;
                    } else {
                        return v;
                    }
                });

                let seekToQuestion = false;

                if (question) {
                    if (!question.complete && this.props.fullVideoQuestions[this.props.count].time <= hoverSeconds) {

                        seekToQuestion = true;
                    }
                } else {
                    if(this.props.fullVideoQuestions[this.props.count].time <= hoverSeconds){

                        seekToQuestion = true;
                    }
                }

                // console.log("Current", this.props.fullVideoQuestions[this.props.count]);
                // console.log("User question", question);
                // console.log("Seek To Q?", seekToQuestion);

                if (seekToQuestion) {

                    this.refs.player.seek(this.props.fullVideoQuestions[this.props.count].time);

                } else {
                    this.refs.player.seek(hoverSeconds);
                }
                /*
                if(this.props.fullVideoQuestions[this.state.count].time > hoverSeconds){
                    // console.log("Is not attempting to seek past question");
                    this.refs.player.seek(hoverSeconds);
                }else {
                    this.refs.player.seek(this.props.fullVideoQuestions[this.state.count].time);
                }

                 */
            }else {
                this.refs.player.seek(hoverSeconds);
            }
        }else{
            this.refs.player.seek(hoverSeconds);
        }


    }
    
    
    
    
    
    
    
    
    /***************************************************************************
     * 
     *  Component Renders
     * 
     * 
     * ************************************************************************/
    
    // Renders
    
    renderBackButton = () => {
        if(this.props.profile.role === "student"){
            return (
                <Link to={`/video/${this.props.userLecture.Lecture.courseId}/${this.props.userLecture.Lecture.subjectId}`}>
                    <i className="zmdi zmdi-arrow-left xl-icon" />
                </Link>    
            )
        }else{
             return (
                <Link to={`/course-admin`}>
                    <i className="zmdi zmdi-arrow-left xl-icon" />
                </Link>    
            )
        }
    }
    
    renderMarks = () => {
        if(this.props.fullVideoQuestions) {
            return this.props.fullVideoQuestions.sort(function(a,b) {
                return (a.time > b.time) ? 1 : ((b.time > a.time) ? -1 : 0)
            } ).map((item, index) => (
                <span
                    key={index}
                    className='video-mark-style'
                    style={{left: `${item.time * 100 / this.state.duration + '%'}`}}
                />
            ))
        }
    };
    
    renderProgressBar = () => {
        let currentFill = this.state.currentPercent;
        let maxTime = 0;
        if(this.state.isDragging){

            currentFill = (this.state.hoverSeconds / this.state.duration) * 100;

        }

        if(this.props.userLecture){
            maxTime = (this.props.userLecture.maxTime / this.state.duration) * 100;
        }
        return (
            <div className="yt-progress-bar">
                <div
                    className="wrap-progress-yt"
                    onMouseMove={this.onMouseMove}
                    onMouseDown={e => this.setState({isDragging: true})}
                    onMouseUp={e => this.setState({isDragging: false})}
                    onMouseLeave={e => this.setState({isDragging: false})}
                    onClick={(e) => this.onSeekVideo(e, this.props.completed)}
                >
                    <div className="duration-bar"></div>
                    <div
                        className="mouse-hover-time"
                        style={{left: `${this.state.left + 'px'}`}}
                    >
                        {this.state.hoverTime}
                    </div>
                    {this.renderMarks(this.props.fullVideoQuestions || [])}
                    <div
                        className='video-progress-pin'
                        style={{
                            left: `${currentFill < 99
                                ? currentFill + '%'
                                : '99%'}`
                        }}

                    />
                    <div className="progress-video-yt"
                            role="progressbar"
                            aria-valuenow={currentFill}
                            aria-valuemin="0"
                            aria-valuemax="100"

                            style={{width: `${currentFill < 99 ? currentFill + '%' : '99%'}`}}
                    >
                    </div>
                    <div className="progress-video-yt-max"
                            role="progressbar"
                            aria-valuenow={maxTime}
                            aria-valuemin="0"
                            aria-valuemax="100"

                            style={{width: `${maxTime < 100 ? maxTime + '%' : '100%'}`}}
                    >
                    </div>
                </div>
                <span className="yt-time">{this.state.currentTime}/{this.state.durationVideo}</span>
            </div>
        )
    }
    
    isSquished = () => {
        if($('.video-react').innerHeight() > this.state.height){
            return true;
        }else{
            return false;
        }
    }
    
    getMaxHeight = () => {
        if(this.state.height > 1000){
            return 1000;
        }else if(this.state.height > 800){
            return 800;
        }else if(this.state.height > 500){
            return 500;
        }else if(this.state.height > 300){
            return 300;
        }
        return Math.floor(this.state.width / 100);
    }
    
    
    renderVideo = (completed) => (
        <div className="panel customPanel video_main_panel user_course_video">
            <div
                // className="panel-body"
                className={`panel-body ${this.state.isFullscreen && 'fullscreenMode'} ${'squished-video-' + this.getMaxHeight()}`}
            >
                <div>

                   {!this.props.embedded ? 
                    this.renderBackButton()
                    : null}

                    {this.props.videoFile &&

                    <Player
                        ref="player"
                        autoPlay={(!this.props.embedded)}

                        
                    >

                        <Shortcut clickable={true} />

                        <source 
                                src={api.makeVideoURL(this.props.videoFile.name)} type="video/mp4" />
                        <ControlBar onKeyDown={(e) => {
                            return false;
                        }} disableDefaultControls={true} autoHide={false}/>


                        <VolumeMenuButton onKeyDown={(e) => {
                            return false;
                        }} vertical={true} disabled/>
                        
                        <div
                            className={`wrap-yt ${this.state.isFullscreen ? 'fullscreen_controlls animated fadeIn' : 'smallscreen_controlls animated fadeIn'}`}
                            style={{display: this.state.show ? "flex" : ''}}
                            onKeyDown={(e) => {
                                return false;
                            }}
                        >

                          
                            {this.renderProgressBar()}
                                
                        <div className="yt-controls-btn">
                            <div className="wrap-yt-btn btn-play-pause">
                                {this.state.player ?
                                this.state.player.paused ?
                                <button
                                    className="btn-player"
                                    onClick={(e) => {
                                        this.play();
                                        return false;
                                    }}
                                >
                                    <i className="zmdi zmdi-play"/>
                                </button>
                                :
                                    <button
                                        className="btn-player"
                                        onClick={(e) => {
                                            this.pause();
                                            return false;
                                        }}
                                    >
                                        <i className="zmdi zmdi-pause"/>
                                    </button>
                                : null
                                }
                                

                                <span
                                    className={`volume-control ${this.state.volumeControl ? 'volume-expanded' : ''}`}
                                    onMouseEnter={(e) => this.setState({volumeControl: true})}
                                    onMouseLeave={(e) => this.setState({volumeControl: false})}
                                >
                                    <button
                                        className="btn-player"
                                        onClick={(e) => {
                                            this.setState({muted: !this.state.muted}, () => {
                                                this.refs.player.muted = this.state.muted;
                                            });
                                        }}
                                    >
                                        <i className={`zmdi ${(this.state.muted === false) ?
                                            (this.state.volume <= 0.5) ? 'zmdi-volume-down' : 'zmdi-volume-up'
                                            : 'zmdi-volume-off'}`} />
                                    </button>
                                    <div
                                        className="progress progress-bar-vertical volume-progress"
                                        onMouseDown={(e) => this.setState({settingVolume: true})}
                                        onMouseUp={(e) => {

                                            let el = document.getElementsByClassName('volume-progress')[0].offsetWidth;
                                            let mouseX = e.nativeEvent.offsetX;
                                            let volume = mouseX / el;
                                            this.setState({volume: volume, settingVolume: false}, () => {
                                                this.refs.player.volume = this.state.volume;
                                            });

                                        }}
                                        onMouseMove={(e) => {
                                            if(this.state.settingVolume) {
                                                let el = document.getElementsByClassName('volume-progress')[0].offsetWidth;
                                                let mouseX = e.nativeEvent.offsetX;
                                                let volume = mouseX / el;
                                                this.setState({volume: volume});
                                            }
                                        }}
                                    >
                                        <div className="progress-bar progress-bar-danger"
                                            role="progressbar"
                                            aria-valuenow="60"
                                            aria-valuemin="0"
                                            aria-valuemax="100"
                                            style={(this.state.muted) ?
                                                {width: "0%"}
                                                : {width: (this.state.volume * 100).toString() + "%"}}
                                        >

                                        </div>
                                    </div>
                                </span>
                                <div className="yt-title-name">
                                    <h1>{this.props.chapterPart.title}</h1>
                                    <p>{this.props.chapterPart.description}</p>
                                </div>
                            </div>

                            <div className="wrap-yt-btn">
                                <button
                                    className="btn-player"
                                    onClick={() => this.setBackward(this.props.marks)}
                                >
                                    <i className="zmdi zmdi-skip-previous"/>
                                </button>

                                {completed &&

                                <button
                                    className="btn-player"
                                    onClick={() => this.setForward()}
                                >
                                    <i className={"zmdi zmdi-skip-next"} alt="revert 15 seconds"/>
                                </button>
                                }
                                



                                {this.refs.player &&
                                <span className="dropdown">
                                        <button
                                            className="btn-player"
                                            data-toggle={"dropdown"}

                                        >
                                            <i className="zmdi zmdi-chevron-up"/>

                                        </button>
                                        <ul className={"dropdown-menu dark-menu"}>
                                            <li className={"menu-title"}>Video Speed</li>
                                            <li>

                                                <a href="" onClick={(e) => {
                                                    e.preventDefault();
                                                    this.changePlaybackRateRate(0.25)
                                                }}><span
                                                    className={`zmdi menu-check ${this.state.playbackRate == 0.25 ? 'zmdi-check' : ''}`}/>
                                                    0.25x</a>
                                            </li>
                                            <li>

                                                <a href="" onClick={(e) => {
                                                    e.preventDefault();
                                                    this.changePlaybackRateRate(0.5)
                                                }}><span
                                                    className={`zmdi menu-check ${this.state.playbackRate == 0.5 ? 'zmdi-check' : ''}`}/>
                                                    0.5x</a>
                                            </li>
                                            <li>

                                                <a href="" onClick={(e) => {
                                                    e.preventDefault();
                                                    this.changePlaybackRateRate(1)
                                                }}><span
                                                    className={`zmdi menu-check ${this.state.playbackRate == 1 ? 'zmdi-check' : ''}`}/>
                                                    1x</a>
                                            </li>
                                            <li>

                                                <a href="" onClick={(e) => {
                                                    e.preventDefault();
                                                    this.changePlaybackRateRate(1.5)
                                                }}><span
                                                    className={`zmdi menu-check ${this.state.playbackRate == 1.5 ? 'zmdi-check' : ''}`}/>
                                                    1.5x</a>
                                            </li>
                                            <li>

                                                <a href="" onClick={(e) => {
                                                    e.preventDefault();
                                                    this.changePlaybackRateRate(2)
                                                }}><span
                                                    className={`zmdi menu-check ${this.state.playbackRate == 2 ? 'zmdi-check' : ''}`}/>
                                                    2x</a>
                                            </li>
                                        </ul>
                                    </span>
                                }

                                {this.props.videoFile.subtitles &&
                                    <button
                                        className="btn-player"
                                        onClick={this.toggleSubtitleShowState}
                                    >
                                        <i className={`zmdi zmdi-closed-caption ${this.state.textTracksMode === "showing" ? 'text-danger' : ''}`}/>
                                    </button>
                                }


                                <button
                                    className="btn-player"
                                    onClick={this.setFullScreen}
                                >
                                    <i className="zmdi zmdi-fullscreen"/>
                                </button>
                            </div>
                        </div>
                    </div>
                    
                    </Player>
                    }
                </div>

            </div>
        </div>
    );
    
    render(){
        return (
            <div>
                {this.renderVideo(this.props.completed)}
            </div>
        )    
    }
}

export default VideoPlayer;


// WEBPACK FOOTER //
// ./src/components/Video/VideoPlayer.js